import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { PublicActivity, PublicApiEndpoints, ActivityUtils } from '@concretecode/shared';
import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { computed, inject } from '@angular/core';
import { BackendApiService } from '@concretecode/data';

type ActivityState = {
  isLoading: boolean;
  activities: PublicActivity[];
  activityOrder: string[];
};

const initialState: ActivityState = {
  isLoading: false,
  activities: [],
  activityOrder: [],
};

export const ActivityStore = signalStore(
  { providedIn: 'root' },
  withDevtools('activity-store'),
  withState(initialState),
  withComputed(({ activities, activityOrder }) => ({
    activitiesCount: computed(() => activities().length),
    hasActivities: computed(() => activities().length > 0),
    sortedActivities: computed((): PublicActivity[] => ActivityUtils.sortActivitiesByOrder(activities(), activityOrder())),
    activityDurationMap: computed(() => new Map<string, number>(activities().map((a) => [a.activityId, a.duration]))),
  })),
  withMethods((store, backendApiService = inject(BackendApiService)) => ({
    updateActivityOrder(activityOrder: string[]): void {
      patchState(store, { activityOrder });
    },
    async loadAllActivities(salonId: string): Promise<void> {
      patchState(store, { isLoading: true });
      const activities = await backendApiService.callPublicEndpoint<PublicActivity[]>(PublicApiEndpoints.activities(salonId), 'GET');
      patchState(store, { activities, isLoading: false });
    },
    reset(): void {
      patchState(store, () => ({ ...initialState }));
    },
  })),
);
